<form [formGroup]='form' (ngSubmit)='submitInventoryZip()'>
  <div class='create-item-container content-container'>
    <div class="adm4-form-group">
      <label class='input-label'>Select file</label>
      <adm4-single-file-input [formControlName]='INVENTORY_ZIP_FORM_CONTROL_NAME'
        [fileExtensions]='[".zip"]'
        [placeholderText]='"Select a .zip file containing an inventory..."'
        [buttonText]='"Select inventory"'
      ></adm4-single-file-input>
    </div>
    <div class='adm4-form-group item-key-group'>
      <div class='input-label'>
        Import as
      </div>
      <mat-radio-group [adm4ControlDisable]='!hasZipSelected' [formControlName]='INVENTORY_KEY_MODE_FORM_CONTROL_NAME'>
        <div class='new-item-group'>
          <div class="item-key-container" [ngbTooltip]='DISABLED_NEW_INVENTORY_MODE_TOOLTIP_TEXT' [disableTooltip]='!shouldShowDisabledNewInventoryModeTooltip' placement='top'>
            <div class='tenant-key-wrapper'>
              <mat-radio-button class="left-align" [disabled]='!canCreateNewInventory' [value]='InventoryKeyMode.New'>New inventory: {{displayTenant? selectedTenant.tenantKey.concat(' - ') : ''}}</mat-radio-button>
              <div class='validation-message-container'></div>
            </div>
            <div class='item-key-input-wrapper'>
              <span class="radio-align-vertically">
                <input class='admn4-text-input form-control' placeholder=' ' name="inventoryKey"
                  [formControlName]='CREATED_INVENTORY_KEY_FORM_CONTROL_NAME'
                  [class.errored]="form.controls[CREATED_INVENTORY_KEY_FORM_CONTROL_NAME].invalid"
                  [adm4ControlDisable]='!canCreateNewInventory'
                  (click)='chooseNewInventoryKeyMode()'/>
              </span>
              <div class='validation-message-container'>
                @if (shouldShowCreatedInventoryKeyErrorMessage("pattern")) {
                  <adm4-validation-message [isError]='true'
                  [message]='ERROR_INVALID_INVENTORY_KEY'></adm4-validation-message>
                }
                @if (shouldShowCreatedInventoryKeyErrorMessage("required")) {
                  <adm4-validation-message [isError]='true'
                  [message]='ERROR_INVENTORY_KEY_REQUIRED'></adm4-validation-message>
                }
                @if (shouldShowCreatedInventoryKeyErrorMessage("inventoryKeyExists")) {
                  <adm4-validation-message [isError]='true'
                  [message]='inventoryForTenantExistsError'></adm4-validation-message>
                }
              </div>
            </div>
          </div>
        </div>
        <div class='new-item-group'>
          <div class="item-key-container" [ngbTooltip]='DISABLED_EXISTING_INVENTORY_MODE_TOOLTIP_TEXT' [disableTooltip]='!shouldShowDisabledExistingInventoryModeTooltip' placement='top'>
            <div class='tenant-key-wrapper'>
              <mat-radio-button class="left-align" [disabled]='!canSelectExistingInventory' [value]='InventoryKeyMode.Existing'>Existing inventory: {{displayTenant? selectedTenant.tenantKey.concat(' - ') : ''}} </mat-radio-button>
              <div class='validation-message-container'></div>
            </div>
            <div class='item-key-input-wrapper'>
              <span class="radio-align-vertically">
                <mat-form-field class='full-width form-field-fix' (click)='chooseExistingInventoryKeyMode()'>
                  <mat-select #inventorySelection
                    [formControlName]='EXISTING_INVENTORY_KEY_FORM_CONTROL_NAME'
                    [adm4ControlDisable]='!canSelectExistingInventory'
                    [disableOptionCentering]="true"
                    (click)='focusDropdownInput()'>
                    @if (inventorySelection.focused) {
                      <adm4-searchable-dropdown-input
                        [sourceItems]='inventoriesWithModifyPermission'
                        [placeholder]="'Please select an inventory...'"
                        [searchableFormatFn]='searchableInventoryFormatFn'
                        [focusTrigger]='searchableDropdownInputFocusTrigger$'
                      (filteredResult)="updateSearchResult($event)"></adm4-searchable-dropdown-input>
                    }
                    @for (inventory of filteredInventoryList; track inventory) {
                      <mat-option [value]="inventory.inventoryKey">
                        {{inventory.inventoryKey | cropTenantFromKey}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </span>
              <div class='validation-message-container'></div>
            </div>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>
  <div mat-dialog-actions>
    <button type='button' class='admn4-button-text'
      (click)='cancel()'>
      Cancel
    </button>
    <button class='admn4-button-ellipse-blue'
      [disabled]='!canImport'>
      Import
    </button>
  </div>
</form>
